import { useEffect, useState } from "react";
import "./AccordionsStyles.css";
import { IFullPlanDetail, IFullPlanDetailPPO } from "../../interfaces/api";
import ComparisonTableVision from "./Accordion/ComparisionTableVision.component";
import ComparisonTableHospital from "./Accordion/ComparisionTableHospital.component";
import ComparisonTableDental from "./Accordion/ComparisionTableDental.component";
import ComparisonTableOverview from "./Accordion/ComparisionTableOverview.component";
import ComparisonTablePrescriptions from "./Accordion/ComparisionTablePrescriptions.component";
import ComparisonTableAdditionalBenefits from "./Accordion/ComparisionTableAdditionalBenefits.component";
import HMOAccordionDetails from "../PlanDetails/HMOAccordionDetails.component";
import PPOAccordionDetails from "../PlanDetails/PPOAccordionDetails.component";
import ComparisonTableDoctors from "./Accordion/ComparisionTableDoctors.component";

const Accordions = ({
  data,
  allAccordionsOpen,
  setAnyAccordionOpen,
  highlightDifferences,
  activePlan,
}: {
  data: IFullPlanDetail[] | IFullPlanDetailPPO[];
  allAccordionsOpen: boolean;
  setAnyAccordionOpen: (isOpen: boolean) => void;
  highlightDifferences: boolean;
  activePlan?: number;
}) => {
  const [isOverviewOpen, setIsOverviewOpen] = useState(true);
  const [isDoctorsOpen, setIsDoctorsOpen] = useState(allAccordionsOpen);

  const [isHospitalOpen, setIsHospitalOpen] = useState(allAccordionsOpen);
  const [isDentalOpen, setIsDentalOpen] = useState(allAccordionsOpen);
  const [isVisionOpen, setIsVisionOpen] = useState(allAccordionsOpen);
  const [isPrescriptions, setIsPrescriptions] = useState(allAccordionsOpen);
  const [isAdditionalBenefits, setIsAdditionalBenefits] =
    useState(allAccordionsOpen);

  const handleOverviewOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsOverviewOpen(!isOverviewOpen);
  };
  const handleDoctorsOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsDoctorsOpen(!isDoctorsOpen);
  };
  const handleHospitalOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsHospitalOpen(!isHospitalOpen);
  };
  const handleDentalOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsDentalOpen(!isDentalOpen);
  };
  const handleVisionOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsVisionOpen(!isVisionOpen);
  };
  const handlePrescriptionsBenefits = (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.preventDefault();
    setIsPrescriptions(!isPrescriptions);
  };
  const handleAdditionalBenefits = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsAdditionalBenefits(!isAdditionalBenefits);
  };

  useEffect(() => {
    setIsHospitalOpen(allAccordionsOpen);
    setIsDentalOpen(allAccordionsOpen);
    setIsVisionOpen(allAccordionsOpen);
    setIsPrescriptions(allAccordionsOpen);
    setIsAdditionalBenefits(allAccordionsOpen);
    setIsDoctorsOpen(allAccordionsOpen);
  }, [allAccordionsOpen]);

  useEffect(() => {
    setAnyAccordionOpen(
      isOverviewOpen ||
        isHospitalOpen ||
        isDentalOpen ||
        isVisionOpen ||
        isPrescriptions ||
        isAdditionalBenefits ||
        isDoctorsOpen
    );
  }, [
    isDentalOpen,
    isHospitalOpen,
    isOverviewOpen,
    isPrescriptions,
    isVisionOpen,
    isAdditionalBenefits,
    setAnyAccordionOpen,
    isDoctorsOpen,
  ]);

  return (
    <div className="grid-x align-center text-center margin-0">
      <section
        className="accordion-container hide-for-small-only"
        style={{ marginBottom: 24 }}
      >
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isOverviewOpen}
              onClick={handleOverviewOpen}
              aria-controls="accordion-content"
            >
              Overview
              <span id="accordion-button-sign">
                {isOverviewOpen ? "-" : "+"}
              </span>
            </button>
          </h2>
        </div>
        <div
          aria-labelledby="accordion-button"
          hidden={!isOverviewOpen}
          role="region"
        >
          <ComparisonTableOverview
            compData={data}
            uniqueName="overview"
            highlightDifferences={highlightDifferences}
          />
        </div>
      </section>{" "}
      <section
        className="accordion-container hide-for-small-only"
        style={{ marginBottom: 24 }}
      >
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isDoctorsOpen}
              onClick={handleDoctorsOpen}
              aria-controls="accordion-content"
            >
              Doctors
              <span id="accordion-button-sign">
                {isDoctorsOpen ? "-" : "+"}
              </span>
            </button>
          </h2>
        </div>
        <div
          aria-labelledby="accordion-button"
          hidden={!isDoctorsOpen}
          role="region"
        >
          <ComparisonTableDoctors
            compData={data}
            uniqueName="doctors"
            highlightDifferences={highlightDifferences}
          />
        </div>
      </section>
      <section
        className="accordion-container hide-for-small-only"
        style={{ marginBottom: 24 }}
      >
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isHospitalOpen}
              onClick={handleHospitalOpen}
              aria-controls="accordion-content"
            >
              Hospital
              <span id="accordion-button-sign">
                {isHospitalOpen ? "-" : "+"}
              </span>
            </button>
          </h2>
        </div>
        <div
          aria-labelledby="accordion-button"
          hidden={!isHospitalOpen}
          role="region"
        >
          <ComparisonTableHospital
            compData={data}
            uniqueName="hospital"
            highlightDifferences={highlightDifferences}
          />
        </div>
      </section>
      <section
        className="accordion-container hide-for-small-only"
        style={{ marginBottom: 24 }}
      >
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isDentalOpen}
              onClick={handleDentalOpen}
              aria-controls="accordion-content"
            >
              Dental
              <span id="accordion-button-sign">{isDentalOpen ? "-" : "+"}</span>
            </button>
          </h2>
        </div>
        <div
          aria-labelledby="accordion-button"
          hidden={!isDentalOpen}
          role="region"
        >
          <ComparisonTableDental
            compData={data}
            uniqueName="dental"
            highlightDifferences={highlightDifferences}
          />
        </div>
      </section>
      <section
        className="accordion-container hide-for-small-only"
        style={{ marginBottom: 24 }}
      >
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isVisionOpen}
              onClick={handleVisionOpen}
              aria-controls="accordion-content"
            >
              Vision
              <span id="accordion-button-sign">{isVisionOpen ? "-" : "+"}</span>
            </button>
          </h2>
        </div>
        <div
          aria-labelledby="accordion-button"
          hidden={!isVisionOpen}
          role="region"
        >
          <ComparisonTableVision
            compData={data}
            uniqueName="vision"
            highlightDifferences={highlightDifferences}
          />
        </div>
      </section>
      <section
        className="accordion-container hide-for-small-only"
        style={{ marginBottom: 24 }}
      >
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isPrescriptions}
              onClick={handlePrescriptionsBenefits}
              aria-controls="accordion-content"
            >
              Prescriptions
              <span id="accordion-button-sign">
                {isPrescriptions ? "-" : "+"}
              </span>
            </button>
          </h2>
        </div>
        <div
          aria-labelledby="accordion-button"
          hidden={!isPrescriptions}
          role="region"
        >
          <ComparisonTablePrescriptions
            compData={data}
            uniqueName="prescriptions"
            highlightDifferences={highlightDifferences}
          />
        </div>
      </section>
      <section
        className="accordion-container hide-for-small-only"
        style={{ marginBottom: 24 }}
      >
        <div id="accordion-title">
          <h2>
            <button
              type="button"
              id="accordion-button"
              aria-expanded={isAdditionalBenefits}
              onClick={handleAdditionalBenefits}
              aria-controls="accordion-content"
            >
              Additional Benefits
              <span id="accordion-button-sign">
                {isAdditionalBenefits ? "-" : "+"}
              </span>
            </button>
          </h2>
        </div>
        <div
          aria-labelledby="accordion-button"
          hidden={!isAdditionalBenefits}
          role="region"
        >
          <ComparisonTableAdditionalBenefits
            compData={data}
            uniqueName="additional-benefits"
            highlightDifferences={highlightDifferences}
          />
        </div>
      </section>
      <section
        className="accordion-container show-for-small-only"
        style={{ marginBottom: 24 }}
      >
        <div
          aria-labelledby="accordion-container"
          role="region"
          style={{ backgroundColor: "white" }}
        >
          {activePlan !== undefined &&
          data[activePlan].PlanDetails[0].company[0].healthPlan[0].lob ===
            "HMO" ? (
            <HMOAccordionDetails
              data={data[activePlan] as IFullPlanDetail}
              allAccordionsOpen={allAccordionsOpen}
              setAnyAccordionOpen={setAnyAccordionOpen}
            />
          ) : (
            activePlan !== undefined && (
              <PPOAccordionDetails
                data={data[activePlan] as IFullPlanDetailPPO}
                allAccordionsOpen={allAccordionsOpen}
                setAnyAccordionOpen={setAnyAccordionOpen}
              />
            )
          )}
        </div>
      </section>
    </div>
  );
};

export default Accordions;
